
import React from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ChatAlertProps {
  apiKeyError: string | null;
  connectionError: boolean;
  hasError: boolean;
  onRetry: () => void;
}

export const ChatAlert: React.FC<ChatAlertProps> = ({
  apiKeyError,
  connectionError,
  hasError,
  onRetry,
}) => {
  if (apiKeyError) {
    return (
      <div className="text-center p-2">
        <div className="flex flex-col items-center gap-1 text-amber-600">
          <AlertCircle className="h-5 w-5" />
          <p className="text-xs">Error de configuración: {apiKeyError}</p>
          <p className="text-xs mt-1">Verifica la clave API de OpenAI en la configuración de Supabase.</p>
        </div>
      </div>
    );
  }
  if (connectionError) {
    return (
      <div className="text-center p-2">
        <div className="flex flex-col items-center gap-2">
          <AlertCircle className="h-5 w-5 text-red-500" />
          <p className="text-xs text-red-500">Hubo un problema con la conexión. Intenta más tarde.</p>
          <Button
            size="sm"
            variant="outline"
            className="mt-1"
            onClick={onRetry}
          >
            Reintentar
          </Button>
        </div>
      </div>
    );
  }
  if (hasError) {
    return (
      <div className="text-center p-2">
        <div className="flex flex-col items-center gap-1 text-red-500">
          <AlertCircle className="h-5 w-5" />
          <p className="text-xs">Hubo un problema con la conexión. Intenta más tarde.</p>
          <Button
            size="sm"
            variant="outline"
            className="mt-1"
            onClick={onRetry}
          >
            Reintentar
          </Button>
        </div>
      </div>
    );
  }
  return null;
};
